import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(({ content, variables, breakpoints }) => ({
  contentSection: {
    display: 'flex',
    flexDirection: 'column',
    padding: variables?.spacingE,
    flex: 1,
    '&.full-screen': {
      width: '100% !important',
      maxWidth: 'unset',
      padding: 0,
    },
    '&.half-screen': {
      //maxWidth: '720px',
      width: '100%',
    },
    '@media screen and (min-width: 1199px)': {
      width: '1200px',
      paddingLeft: variables?.spacingD,
      paddingRight: variables?.spacingD,
    },
    '@media only screen and (min-width: 1025px) and (max-width: 1199px)': {
      width: '928px',
      paddingLeft: variables?.spacingD,
      paddingRight: variables?.spacingD,
    },
    '@media only screen and (min-width: 992px) and (max-width: 1024px)': {
      maxWidth: '928px',
      paddingLeft: variables?.spacingD,
      paddingRight: variables?.spacingD,
      '&.half-screen': {
        maxWidth: 'inherit',
        width: '100%',
      },
    },
    '@media only screen and (min-width: 768px) and (max-width: 991px)': {
      maxWidth: '688px',
      paddingLeft: variables?.spacingD,
      paddingRight: variables?.spacingD,
      '&.half-screen': {
        maxWidth: 'inherit',
        width: '100%',
      },
    },
    '@media only screen and (min-width: 360px) and (max-width: 767px)': {
      width: '100%',
      minWidth: '360px',
      paddingLeft: variables?.spacingD,
      paddingRight: variables?.spacingD,
    },
  },
}));

export default useStyles;
